import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import React from 'react'
import {useAppActions} from '../../../../hooks/runtime'
import s from '../policy-checkbox.scss'
import {PolicyListProps} from './interfaces'

export const PolicyList = ({policies}: PolicyListProps) => {
  const {openPolicyDetailsModal} = useAppActions()

  return (
    <>
      {policies.map((policy, index) => {
        const last = policies.length - 1 === index

        return (
          <>
            <a
              data-hook={DH.POLICY}
              className={s.policy}
              href="#"
              onClick={event => {
                event.preventDefault()
                openPolicyDetailsModal(policy)
              }}
              data-index={index}
              tabIndex={0}
            >
              {policy.name}
              {last ? '' : ','}
            </a>
            {last ? '' : ' '}
          </>
        )
      })}
    </>
  )
}
